export enum FormStatus {
  Submitted = 'Submitted',
  NotSubmitted = 'Not submitted'
}
